import React from "react";
import "./CompanyAndSharesResult.css";
import { Text, View } from "@react-pdf/renderer";
import { styles } from "../styles/Slide4Styles";
import { CountryType, FoundersType } from "../ResultContext";
import ResultsNavigationBar from "../components/ResultsNavigationBar";

export function Slide4({
  foundersResult,
  rolesResponsibilitiesResult,
}: {
  foundersResult: {
    name: string;
    country: CountryType;
    type: FoundersType;
  }[];
  rolesResponsibilitiesResult: { tags: string[]; extra: string }[];
}) {
  if (!foundersResult || !rolesResponsibilitiesResult) {
    return <Text>Not all information is filled in for this section</Text>;
  }
  if (foundersResult.length !== rolesResponsibilitiesResult.length) {
    return (
      <Text>
        The number of founders is not equal to the length of the responsibilites
        list.
      </Text>
    );
  }
  return (
    <View style={styles.backgroundBlue}>
      <ResultsNavigationBar selectIdx={2} />
      <View style={styles.rolesResponsibilitiesContainer}>
        {foundersResult.map((item, index) => {
          const rolesResponsiblities = rolesResponsibilitiesResult[index];
          return (
            <View style={styles.rolesResponsibilitiesBox} key={index}>
              <View style={styles.foundersBox}>
                <Text style={styles.textFounders}>{item.name}</Text>
              </View>
              <View style={styles.titleBox}>
                <Text style={styles.textRR}>Roles & Responsibilities</Text>
              </View>
              <View style={styles.tagBox}>
                {rolesResponsiblities
                  ? rolesResponsiblities.tags.map((tag, tagIndex) => {
                      return (
                        <Text style={styles.textTag} key={tagIndex}>
                          - {tag}
                        </Text>
                      );
                    })
                  : null}
              </View>
            </View>
          );
        })}
      </View>
      ;
    </View>
  );
}
